module.exports = __webpack_public_path__ + "download@2x.png?8a12d81c0d92fe6a59133b8c7e2a1a1a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download@2x.png
// module id = 29
// module chunks = 0